import { Button } from "@/components/ui/button";
import { Navbar } from "@/components/Navbar";
import { useNavigate } from "react-router-dom";

const HireDevelopers = () => {
  const navigate = useNavigate();

  const handleHiringClick = () => {
    navigate("/auth", { state: { preselectedType: "company" } });
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-primary mb-6">
              Build Your Dream Team with
              <span className="block text-secondary">Pre-vetted Developers</span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              Access a curated network of exceptional software engineers ready to help you scale your business.
            </p>
            <Button 
              size="lg" 
              className="bg-primary hover:bg-primary/90"
              onClick={handleHiringClick}
            >
              Start Hiring Now
            </Button>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center mb-12">Why Choose Triple Digit Talent?</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="p-6 bg-white rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold mb-4">Pre-vetted Talent</h3>
              <p className="text-gray-600">
                All our developers go through a rigorous vetting process to ensure top-tier quality and expertise.
              </p>
            </div>
            <div className="p-6 bg-white rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold mb-4">Fast Matching</h3>
              <p className="text-gray-600">
                Get matched with the perfect developer for your project within 48 hours.
              </p>
            </div>
            <div className="p-6 bg-white rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold mb-4">Risk-Free Trial</h3>
              <p className="text-gray-600">
                Start with a trial period to ensure the perfect fit for your team.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center mb-12">How It Works</h2>
          <div className="grid md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-12 h-12 bg-primary text-white rounded-full flex items-center justify-center mx-auto mb-4">1</div>
              <h3 className="font-semibold mb-2">Tell Us Your Needs</h3>
              <p className="text-gray-600">Share your requirements and team structure</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-primary text-white rounded-full flex items-center justify-center mx-auto mb-4">2</div>
              <h3 className="font-semibold mb-2">Meet Developers</h3>
              <p className="text-gray-600">Interview pre-screened candidates</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-primary text-white rounded-full flex items-center justify-center mx-auto mb-4">3</div>
              <h3 className="font-semibold mb-2">Trial Period</h3>
              <p className="text-gray-600">Start with a risk-free trial period</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-primary text-white rounded-full flex items-center justify-center mx-auto mb-4">4</div>
              <h3 className="font-semibold mb-2">Scale Your Team</h3>
              <p className="text-gray-600">Seamlessly integrate developers into your team</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to Scale Your Team?</h2>
          <p className="text-lg mb-8 opacity-90 max-w-2xl mx-auto">
            Get started today and find the perfect developer for your project within 48 hours.
          </p>
          <Button 
            size="lg" 
            className="bg-white text-primary hover:bg-gray-100"
            onClick={handleHiringClick}
          >
            Start Hiring Now
          </Button>
        </div>
      </section>
    </div>
  );
};

export default HireDevelopers;